export default __webpack_public_path__ + "static/media/contract-us.16031c81.jpg";